<template>
  <v-container fluid>
    <subHeader />
    <v-container fluid style="max-width: 1266px">
      <v-row>
        <div style="width: 1266px !important; padding-bottom: 1rem">
          <h2>
            UK/EU Fare Refresher Webinar
          </h2>
          <p style="margin-top: 15px;">
            At Air New Zealand we’re committed to providing you with the information and tools you need to sell our products and fares. We understand that learning can be different for all of our agents whether you’re based in a store or working from home, and so it’s important to us you have the choice to choose from completing learning modules on duo or joining us in person for some face-to-face training.
            <br/><br/>
            Over the next 12 months, we’ll be offering some new in person training opportunities to have a refresher on our fares. 
            <br/><br/>
            <b>Spots are limited – register now to secure your place!</b>
            <br/><br/>
            <b>Join us for an exclusive refresher course to help you further your knowledge on Air New Zealand UK/EU Shortlife Fares.</b>
          </p>
          <br />
          <div style="background-color:white; margin-bottom:1.5vw; padding:1.5vw;" class="pl-12">
            <p>
              <b>What to expect: </b>
            </p>
            An interactive session regarding our UK & Europe special fares including NZ/SQ JV fares.
            <br style="margin-bottom: 10px;"/>
                A short quiz at the end to reinforce key takeaways
            <br style="margin-bottom: 10px;"/>
                As always, a chance to win a prize!
          </div>
          <div style="margin-bottom:1.5vw; padding-left:1.5vw; padding-right:1.5vw;" class="pl-12">
            <p>
              <b>Dates: </b>
            </p>
                <b>Monday 1st September</b> 10am - 11am and 2pm - 3pm
            <br/>    
                <b>Tuesday 2nd September</b> 10am - 11am and 2pm - 3pm
            <br/>
                <b>Wednesday 3rd September</b> 10am - 11am and 2pm - 3pm 
            <br/>
                <b>Thursday 4th September</b> 10am - 11am and 2pm - 3pm
          </div>

          <div>
            <v-btn
              style="width: 243px; height: 50px; font-size: 16px"
              color="#00b0b9"
              class="mt-4 mr-4"
              :elevation="0"
              bottom
              dark
              @click="showSlotTimeDialog = true;"
              >Register Now</v-btn
            >
          </div>
          
        </div>
      </v-row>

      <v-dialog v-model="showSlotTimeDialog" persistent width="800px">
        <v-card class="white" height="100%" :style="{ borderRadius: '8px'}">
          <v-card-title class="pa-1 pl-6" :style="{ backgroundColor: '#00AFB9' }">
            <span class="notification-title-text-style">Choose Time Slot</span>
            <v-spacer></v-spacer>
            <v-btn icon x-large color="white" @click="showSlotTimeDialog = false"><v-icon>mdi-close</v-icon></v-btn>
          </v-card-title>
          <v-card-text class="pt-6">
            <v-row justify="center">
              <v-col class="d-flex justify-center">
                <v-btn-toggle
                  v-model="slotTime"
                  background-color="#00AFB9"
                  color="#00AFB9"
                  rounded="0"
                  tile
                  group
                  block
                  style="flex-direction:column;"
                >
                  <v-btn v-for="(value, index) in times" :key="index" :value="value">{{ value }}</v-btn>
                </v-btn-toggle>
              </v-col>
            </v-row>
          </v-card-text>
          <v-card-actions class="justify-center" :style="{ paddingBottom: '20px'}">
            <v-spacer></v-spacer>
            <v-btn height="45" width="120"
              style="font-size: 16px; background-color: #01b0b9 !important; color: white; text-transform: none !important;"
              @click="showSlotTimeDialog = false; submitSlot();">
              Submit
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-container>
  </v-container>
</template>

<style scoped>
h2 {
  font-family: "AirNZ Sans Regular";
  font-size: 22px;
}
</style>

<script>
/* eslint-disable no-console */
import axios from "axios";
import subHeader from "./subHeader.vue";

export default {
  components: {
    subHeader,
  },
  data() {
    return {
      showSlotTimeDialog: false,
      slotTime: "",
      times: [],
      campaignName: 'Fare Refresh'
    };
  },
  mounted() {
    this.getTimeSlots();
  },
  methods: {
    getTimeSlots() {
      axios.
        post("/system/slot/times", {
                    campaignName: this.campaignName,
                })
        .then(response => {
          this.times = response.data;
        })
        .catch(error => {
          console.error("There was an error fetching time slots: ", error);
        });
    },
    submitSlot() {
            axios
        .post("/system/slot/save", {
                    slotTime: this.slotTime,
          campaignName: this.campaignName,
          campaignDate: "2025-08-01"
                })
                .then((response) => {
          var status = response.data.value ?? 'submitted'
                    // show notif
                    this.$store.commit("showNotification", 
                        {     
              title: "Awesome", 
                            content: "Thanks you’ve now " + status.toLowerCase() + " for the " + this.slotTime + " slot in the incentive.", 
                            color: "#00AFB9",
                            buttonText: "OK"
                        }
                    );
                });
        },
    },
};
</script>
